interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, i) => i + 1);

  return (
    <nav className="flex items-center justify-center gap-2 mt-8" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="w-9 h-9 rounded-md flex items-center justify-center border border-background-300 text-foreground-700 cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-400 hover:text-primary-600 transition-colors"
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line"></i>
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`w-9 h-9 rounded-md flex items-center justify-center text-sm cursor-pointer transition-colors ${
            page === current
              ? 'bg-primary-500 text-background-50'
              : 'border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600'
          }`}
          aria-current={page === current ? 'page' : undefined}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="w-9 h-9 rounded-md flex items-center justify-center border border-background-300 text-foreground-700 cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed hover:border-primary-400 hover:text-primary-600 transition-colors"
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}